import React, { useEffect, useState } from 'react'
import { getTestimoniList } from '../../../services/testimoni'
import { Box, Text, Grid, Skeleton, Paper, Flex, Group, Divider, Avatar, Rating, Container } from '@mantine/core'
import { getImageFile } from '../../../services/fileImage'
// import classes from '../Program/details/DetailSlug.module.css'
import classes from '../../../pages/Home/Home.module.css'
import Carousel from 'react-multi-carousel'
import { useViewportSize } from '@mantine/hooks'
import "react-multi-carousel/lib/styles.css"

const defaultParameter = {
  isGlobal: 1,
  orderBy: 'order',
  order: 'desc',
  skip: 0,
  take: 10
}

const TestimoniSection = () => {
  const { width } = useViewportSize()
  const [loading, setLoading] = useState(true)
  const [reviewList, setReviewList] = useState([])

  const handleGetReviewProgram = async () => {
    setLoading(true)
    try {
      const response = await getTestimoniList(defaultParameter)
      setReviewList(response.data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const defaultResponsive = {
    desktop: {
      breakpoint: {
        max: 3000,
        min: 1024
      },
      items: 3,
      partialVisibilityGutter: 40
    },
    mobile: {
      breakpoint: {
        max: 464,
        min: 0
      },
      items: 1,
      partialVisibilityGutter: 30
    },
    tablet: {
      breakpoint: {
        max: 1024,
        min: 464
      },
      items: 2,
      partialVisibilityGutter: 30
    }
  };

  useEffect(() => {
    handleGetReviewProgram()
    // eslint-disable-next-line
  }, [])

  const loadingReview = () => {
    const loadingDataReview = (number) => Array.from({ length: number }, (_, i) => {
      return (
        <Grid.Col span={{ base: 12, lg: 4 }} key={i}>
          <Paper shadow="sm" radius="md" withBorder p="md">
            <Group align='center'>
              <Skeleton height={50} circle />
              <Box style={{ width: '50%' }}>
                <Skeleton height={16} width='80%' mb={6} radius="xl" />
                <Skeleton height={12} width='40%' radius="xl" />
              </Box>
            </Group>
            <Divider my="md" />
            <Skeleton height={14} mb={8} radius="xl" />
            <Skeleton height={14} mb={8} radius="xl" />
            <Skeleton height={14} mb={8} radius="xl" />
            <Skeleton height={14} mb={8} radius="xl" />
          </Paper>
        </Grid.Col>
      )
    })
    return (
      <Grid gutter="lg" mt={100}>
        {loadingDataReview(3)}
      </Grid>
    )
  }

  const mappingReview = (dataReview) => {
    const mappingListReview = (dataReview) => dataReview.map((val, index) => {
      console.log('ini val', val)
      return (
        <Box p='sm'>
          <Paper shadow="sm" radius="md" withBorder p="md" key={index}>
            <Flex gap='sm' align='center'>
              <Avatar size={55} radius="md" src={val.userEventCompletion.userEvent.user.image !== null ? getImageFile(val.userEventCompletion.userEvent.user.image) : null} style={{ border: '1px solid #BF6D0F' }} />
              <Box>
                <Text fw='600' fz={width > 768 ? 12.5 : 11.5} mb={1} lineClamp={1}>{val.userEventCompletion.userEvent.user.fullName}</Text>
                <Text fw='600' fz={width > 768 ? 11.5 : 10.5} mb={3} lineClamp={2} c='#BF6D0F'>{val.userEventCompletion.userEvent.eventSchedule.event.name}</Text>
                <Rating size='xs' defaultValue={val.userEventCompletion.userRating} fractions={5} readOnly />
              </Box>
            </Flex>
            <Divider my="md" />
            <Box h={100}>
              <Text fz={11.5} fw={500} lineClamp={5}>{val.userEventCompletion.userComment}</Text>
            </Box>
          </Paper>
        </Box>
      )
    })

    if (dataReview.length > 0) {
      return (
        <Box>
          <Container fluid className={classes.section}>
            <Box className={classes.paddingPage} align="center">
              <Text className={classes.titleSection} mb={8}>Testimoni</Text>
              <Text fz="lg" mb={50}>Dari alumni yang telah mengikuti program - program dari Laju Reaksi</Text>
            </Box>
          </Container>
          <Box pos='relative' mt={40}>
            <Carousel
              arrows
              swipeable
              autoPlay
              autoPlaySpeed={3000}
              responsive={defaultResponsive}
              infinite
            >
              {mappingListReview(dataReview)}
            </Carousel>
          </Box>
        </Box>
      )
    }
  } 

  if (!loading && reviewList.length > 0) {
    return (
      <Box className={classes.defaultSection} mb={{ base: 0, lg: 40 }}>
        {loading ? loadingReview() : mappingReview(reviewList)}
      </Box>
    )
  }
  
}

export default TestimoniSection